import { Field } from 'formik';
import { TextField } from '@material-ui/core';
import React from 'react';

export const StripTextField = ({ label, name, errors, touched, disabled = false }) => {
  return (
    <Field
      as={TextField}
      name={name}
      label={label}
      margin="dense"
      variant="filled"
      disabled={disabled}
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
      error={Boolean(errors[name]) && touched[name]}
      helperText={Boolean(errors[name]) && touched[name] ? errors[name] : ''}
      inputProps={{
        maxLength: 100,
      }}
    />
  );
};
